<template>
  <div class="content">
    <center-nav ref="centerNav" @getBuySeatIndex="getBuySeat"></center-nav>
    <!--    有小程序座位席位时且绑定了小程序-->
    <slider-menu
      v-if="seatNum > 0 && openAppList.length > 0 && isMerchant == 1"
      :menuData="menuData"
    ></slider-menu>
    <creditCard v-if="seatNum === 0"></creditCard>
    <authorization
      v-if="openAppList.length > 0 && isMerchant == 0"
      @getBuySeat="getBuySeat"
    ></authorization>
    <auto v-if="seatNum > 0 && openAppList.length === 0 && !isAuto"></auto>
  </div>
</template>

<script>
import mini from "@/api/mini";
import centerNav from "../../../components/centerNav";
import sliderMenu from "@/components/SliderMenu";
import creditCard from "../../pc/miniProgram/creditCard/index";
import authorization from "../../pc/miniProgram/authorization/index";
import pay from "../../pc/miniProgram/pay/index";
import auto from "../../pc/miniProgram/auto/index";

const miniModel = new mini();
export default {
  components: {
    centerNav, // 头部导航
    sliderMenu, // 侧边栏
    creditCard,
    authorization,
    pay,
    auto,
  },
  data() {
    return {
      seatNum: "", //小程序席位数量
      openAppList: [],
      isAuto: false, //是否授权
      packagePitList: [],
      isMerchant: 0, // 是否已经绑定商户号
      ipOpenCoupon: false, // 优惠券开关
      menuData: [
        {
          path: "/pc/miniProgram/home",
          icon: "icon-xcx_refresh_home_n_1",
          title: "主页",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/miniProgram/user",
          icon: "icon-xcx_refresh_user_n_2",
          title: "用户列表",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/miniProgram/orderMovie",
          icon: "icon-xcx_refresh_order_n_3",
          title: "影票订单",
          iconSize: "16px",
          hidden: false,
          children: [
            {
              path: "/pc/miniProgram/order",
              title: "小程序推广订单",
            },
          ],
        },

        {
          path: "/pc/miniProgram/audit",
          icon: "icon-xcx_refresh_await_n_5",
          title: "提现审核",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/miniProgram/financialDetails",
          icon: "icon-xcx_refresh_detail_n_6",
          title: "资金明细",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/miniProgram/couponParams",
          icon: "icon-xcx_refresh_detail_n_6",
          title: "活动中心",
          iconSize: "16px",
          hidden: false,
          children:[]
        },
        {
          path: "/pc/miniProgram/set",
          icon: "icon-xcx_refresh_set_n_8",
          title: "基础设置",
          hidden: false,
          iconSize: "16px",
        },
      ],
    };
  },
  computed: {
    isSaasProxyUser: function () {
      return this.$store.getters.isSaasProxyUser;
    },
  },
  created() {
    console.log("SDFFH11111");
    // this.getBuySeat();
    console.log(this.$route.query, "AAAA====");
    this.$router.push("/pc/miniProgram/home");
  },
  async mounted() {
    await this.getBuySeat();
    let couponIndex = this.setCouponParams()
    console.log(this.isSaasProxyUser, "this.isSaasProxyUser==1");
    let miniAppType = localStorage.getItem("miniAppType");
    console.log(miniAppType, "miniAppType== 3和undefined开启==");
    let appKey = localStorage.getItem("appKeyMini");
    if (this.$route.query.isAuto) {
      this.isAuto = this.$route.query.isAuto;
    }
    console.log("SDFFH");
    // await this.getBuySeat();
    // miniAppType：1淘宝，2天猫，3抖音，4支付宝，5快手
    // 快手、支付宝、淘宝、天猫、好影抖音影藏 活动中心菜单栏
    // 极光测试环境：16045865425：好影：19235541328正式环境：好影：16663046825
    // 微信和抖音显示活动中心 + 快手极光小程序'14447955848'
    // 极光：16045865425测试环境：好影：19235541328正式环境：好影：16663046825
    let couponArr = ["1", "2", "4", "5"];
    console.log(couponArr.indexOf(miniAppType), "ASD");
    // 微信和抖音极光显示 【活动中心】。抖音好影隐藏【活动中心】 isSaasProxyUser==1
    console.log(miniAppType, "miniAppTypeminiAppTypeminiAppTypeminiAppType");
    let couponItems = this.menuData[couponIndex]
    if (miniAppType == "0" || (miniAppType == "3" && this.isSaasProxyUser != 1)) {
      this.getUserCoupon(couponIndex);
    } else if (miniAppType == "5") {
      // let items = this.menuData[couponIndex];
      // items.children.push({
      //   path: "/pc/miniProgram/couponGroup",
      //   title: "团购券",
      // })
      // this.$set(this.menuData, couponIndex, items);
      // let activeItem = {
      //   path: "/pc/miniProgram/couponParams",
      //   icon: "icon-xcx_refresh_detail_n_6",
      //   title: "活动中心",
      //   iconSize: "16px",
      //   hidden: false,
      //   children: [
      //     {
      //       path: "/pc/miniProgram/couponGroup",
      //       title: "团购券",
      //     },
      //   ],
      // };
      //
      couponItems.children.push(
        {
          path: "/pc/miniProgram/couponGroup",
          title: "团购券",
        },
      )
      this.$set(this.menuData, couponIndex, couponItems);
      let arr = this.menuData;
      // arr.splice(5, 0, activeItem);
      //
      arr.forEach((item) => {
        if (item.title === "影票订单") {
          item.children.push({
            path: "/pc/miniProgram/groupOrder",
            title: "团购订单",
          });
        }
      });
      this.menuData = [...arr];
    }else if(miniAppType == "1" || miniAppType == "2" && this.isSaasProxyUser != 1) {
      // let activeItem = {
      //   path: "/pc/miniProgram/couponParams",
      //   icon: "icon-xcx_refresh_detail_n_6",
      //   title: "活动中心",
      //   iconSize: "16px",
      //   hidden: false,
      //   children: [
      //     {
      //       path: "/pc/miniProgram/couponTaoBao",
      //       title: "天猫券",
      //     },
      //   ],
      // };
      //
      // let arr = this.menuData;
      // arr.splice(5, 0, activeItem);
      // this.menuData = [...arr];
      // couponItems.children.push(
      //   {
      //     path: "/pc/miniProgram/couponTaoBao",
      //     title: "天猫券",
      //   }
      // )
      // this.$set(this.menuData, couponIndex, coup onItems);
    }else if (miniAppType == '6'){
      const temp = {
        path: "/pc/miniProgram/xhsProductionCenter",
        icon: "icon-xcx_refresh_detail_n_6",
        title: "小红书商品中心",
        hidden: false,
        iconSize: "16px",
      }
      this.menuData.splice(6, 0, temp);
    }

    // miniAppType：1淘宝，2天猫，3抖音，4支付宝，5快手，禁用菜单“推广工具”
    let miniAppTypeArr = ["1", "2", "3", "4", "5"];

    console.log(miniAppTypeArr.indexOf(miniAppType), "ASD==miniAppType");
    console.log(miniAppType, "miniAppType==");
    if (miniAppType !== null && miniAppTypeArr.indexOf(miniAppType) === -1) {
      this.menuData.push({
        path: "/pc/miniProgram/promotion",
        icon: "icon-xcx_refresh_tool_n_7",
        title: "推广工具",
        iconSize: "16px",
        hidden: false,
        children: [
          {
            path: "/pc/miniProgram/promotionManage",
            title: "推广位管理",
          },
          {
            path: "/pc/miniProgram/statisticalData",
            title: "统计数据",
          },
        ],
      });
    }
    this.isDyJiGuang()
    await this.getSet(couponIndex)
    if(!this.menuData[couponIndex].children || this.menuData[couponIndex].children.length === 0) {
      // 删除其中一项
      this.menuData.splice(couponIndex, 1);
    }
  },
  methods: {
    isDyJiGuang() {

      let miniAppType = localStorage.getItem("miniAppType");
      let appKeyMini = localStorage.getItem("appKeyMini");
      const temp = {
          path: "/pc/miniProgram/poiCps",
          icon: "icon-gzh_refresh_renew_n_9",
          title: "POI-CPS管理",
          hidden: false,
          iconSize: "16px",
          children:[
            {
              path: "/pc/miniProgram/poiCps",
              title: "CPS计划管理",
            },
            {
              path: "/pc/miniProgram/poiCps/groupLeaderDistribution",
              title: "团长分销管理",
            },
          ]
      }
      if(["3"].includes(miniAppType) && '16045865425'.includes(appKeyMini)) {
        this.menuData.splice(this.menuData.length - 1, 0, temp);
      }
    },
    setCouponParams() {
      return  this.menuData.findIndex(item => {
        return item.path === '/pc/miniProgram/couponParams'
      })
    },
    async getSet(couponIndex) {
      const res = await miniModel.setMini({
        appKey: localStorage.getItem("appKeyMini"),
      })
      console.log(res,'getSetgetSet==')
      if(res.data.code !== 200) {
        this.$message.error(res.data.message || '获取菜单设置失败')
        return
      }
      let couponItems = this.menuData[couponIndex]
      let data = res.data.data
      let couponTypeList = data.couponType ? data.couponType.split(',').map(Number) : [];
      // miniAppType：0微信 1淘宝，2天猫，3抖音，4支付宝，5快手
      let miniAppType = localStorage.getItem("miniAppType");
      let appKeyMini = localStorage.getItem("appKeyMini");
      if(data.openCoupon) {
        if (miniAppType == "5") {
          console.log('快手团购开启')
          if(couponTypeList.includes(30)) {
            couponItems.children.push({
              path: "/pc/miniProgram/couponGroupNew",
              title: "团购券-新",
            })
          }
          if(couponTypeList.includes(82)) {
            console.log('快手店兑换券开启')
            couponItems.children.push(
              {
                path: '/pc/miniProgram/ksCouponExchange',
                title: '快手店兑换券',
              },
            )
          }
          this.$set(this.menuData, couponIndex, couponItems);
        }else if(miniAppType == "3"){
          if(couponTypeList.includes(40)) {
            console.log('抖音小店开启')
            couponItems.children.push(
              {
                path: '/pc/miniProgram/ddCouponExchangeNew',
                title: '抖店兑换券-新',
              },
            )
          }
          if(couponTypeList.includes(80)) {
            console.log('抖音POI开启')
            couponItems.children.push(
              {
                path: '/pc/miniProgram/couponDyPoiNew',
                title: 'POI专属',
              },
            )
          }
          this.$set(this.menuData, couponIndex, couponItems);
        }else if(miniAppType == "4" && couponTypeList.includes(50)){
          console.log('支付宝开启')
        }else if((miniAppType == "2" || miniAppType == "1")){
          console.log('天猫券开启')
          if(couponTypeList.includes(60)) {
            couponItems.children.push({
              path: "/pc/miniProgram/couponTaoBaoNew",
              title: "天猫券",
            })
          }
          this.$set(this.menuData, couponIndex, couponItems);
        }else if(miniAppType == "0"){
          if(couponTypeList.includes(40)) {
            console.log('抖音小店开启')
            couponItems.children.push(
              {
                path: '/pc/miniProgram/ddCouponExchangeNew',
                title: '抖店兑换券',
              },
            )
          }
          this.$set(this.menuData, couponIndex, couponItems);
        }
      }
    },
    hiddenDyCoupon(){
      let miniAppType = localStorage.getItem("miniAppType");
      if(["0"].includes(miniAppType)){
        return !['16663046825','16239425157','15982205239','19478086621', '15007009408','10865010118','13385670860'].includes(localStorage.getItem("appKeyMini"));
      }
      return !["3"].includes(miniAppType)
    },
    // 获取优惠券开关
    getUserCoupon(couponIndex) {
      let appKeyMini = localStorage.getItem("appKeyMini");
      let miniAppType = localStorage.getItem("miniAppType");
      miniModel
        .userCoupon({
          appKey: appKeyMini,
        })
        .then((res) => {
          if (res.data.code == 200) {
            let couponItems = this.menuData[couponIndex]
            console.log("获取优惠券开关菜单==", res);
            console.log(res.data.data.isOpenCoupon, "后台是否开启优惠券菜单权限");
            this.$store.commit("nav/SET_ISOPEN_DOUYIN", res.data.data.isDy);

            couponItems.children.push(
              {
                path: '/pc/miniProgram/ddCouponExchange',
                title: '抖店兑换券',
                hidden: this.hiddenDyCoupon(),
              },
              // {
              //   path: '/pc/miniProgram/couponDyPoi',
              //   title: 'POI专属',
              //   hidden: !["16045865425"].includes(appKeyMini),
              // },
            )
            // 开启优惠券才有微信活动中心
            if (res.data.data.isOpenCoupon == 1) {
              couponItems.children.push(
                {
                  path: "/pc/miniProgram/coupon",
                  title: "小程序内部券",
                  hidden: !["0", "3"].includes(miniAppType),
                },
                {
                  path: "/pc/miniProgram/couponNew",
                  title: "小程序内部券-新",
                  hidden: !["0", "3"].includes(miniAppType),
                },
                {
                  path: "/pc/miniProgram/couponJd",
                  title: "京东福利券",
                  hidden: !['15475958839','19478086621'].includes(localStorage.getItem("appKeyMini")),
                },
                {
                  path: '/pc/miniProgram/couponDy',
                  title: '抖音小程序营销券',
                  hidden: !["3"].includes(miniAppType),
                },
              )
              this.$set(this.menuData, couponIndex, couponItems);
            }else{

            }
          }
        });
    },
    // 获取购买席位数量
    async getBuySeat(appKey) {
      await miniModel
        .getMiniNum({
          channelType: 0,
        })
        .then((res) => {
          console.log(res, "获取购买席位数量");
          if (res.data.code == 200) {
            this.seatNum = res.data.data.openAppList.length;
            this.packagePitList = res.data.data.packagePitList;
            this.openAppList = res.data.data.openAppList;

            if (this.openAppList.length == 0) return;
            console.log("openAppList有数据wx");
            // 设置缓存
            let miniActive = localStorage.getItem("miniActive");
            console.log(miniActive, "miniActive===223");
            if (miniActive === null) {
              console.log("VVV=111=miniActive为null");
              // 取第一个
              this.isMerchant = this.openAppList[0].isMerchant;
              localStorage.setItem("isMerchant", this.openAppList[0].isMerchant);
              localStorage.setItem("miniAppType", this.openAppList[0].miniAppType);
              localStorage.setItem("miniActive", 0);
              localStorage.setItem("appId", this.openAppList[0].id);
              localStorage.setItem("appKeyMini", this.openAppList[0].appKey);
              localStorage.setItem("appName", this.openAppList[0].appName);
              localStorage.setItem("nowMini", JSON.stringify(this.openAppList[0]));
            } else {
              console.log(this.openAppList[miniActive], "this.openAppList[miniActive]");
              if (this.openAppList[miniActive]) {
                console.log("有==11");

                this.isMerchant = this.openAppList[miniActive].isMerchant;
                localStorage.setItem(
                  "isMerchant",
                  this.openAppList[miniActive].isMerchant
                );
                localStorage.setItem(
                  "miniAppType",
                  this.openAppList[miniActive].miniAppType
                );
                // localStorage.setItem('miniActive', 0)
                localStorage.setItem("appId", this.openAppList[miniActive].id);
                localStorage.setItem("appKeyMini", this.openAppList[miniActive].appKey);
                localStorage.setItem("appName", this.openAppList[miniActive].appName);
                localStorage.setItem("nowMini", JSON.stringify(this.openAppList[miniActive]));
              } else {
                // 索引超出时，取第一个
                console.log("没有==11");
                // 取第一个
                this.isMerchant = this.openAppList[0].isMerchant;
                localStorage.setItem("isMerchant", this.openAppList[0].isMerchant);
                localStorage.setItem("miniAppType", this.openAppList[0].miniAppType);
                localStorage.setItem("miniActive", 0);
                localStorage.setItem("appId", this.openAppList[0].id);
                localStorage.setItem("appKeyMini", this.openAppList[0].appKey);
                localStorage.setItem("appName", this.openAppList[0].appName);
                localStorage.setItem("nowMini", JSON.stringify(this.openAppList[0]));
              }
            }

            if (appKey != undefined) {
              console.log("授权资质AA");
              for (let index in this.openAppList) {
                if (this.openAppList[index].appKey == appKey) {
                  this.isMerchant = this.openAppList[index].isMerchant;
                  localStorage.setItem("isMerchant", this.openAppList[index].isMerchant);
                }
              }
            } else {
              console.log("授权资质BB");
              if (localStorage.getItem("isMerchant")) {
                this.isMerchant = localStorage.getItem("isMerchant");
              } else {
                if (this.openAppList.length > 0) {
                  this.isMerchant = this.openAppList[0].isMerchant;
                }
              }

              console.log(this.$route.query.appKey, "this.$route.query.appKey");
              console.log(this.$route.query, "this.$route.query");
              // 授权页面传值，选中对应项
              if (this.$route.query.appKey) {
                console.log("有传appkey");
                for (let index in this.openAppList) {
                  console.log("循环");
                  // appkey相同
                  if (this.openAppList[index].appKey == this.$route.query.appKey) {
                    // 是否打开授权页面
                    this.isMerchant = this.openAppList[index].isMerchant;
                    localStorage.setItem(
                      "isMerchant",
                      this.openAppList[index].isMerchant
                    );
                    localStorage.setItem("miniActive", index);
                    // appkey
                    localStorage.setItem("appKeyMini", this.$route.query.appKey);
                    // id
                    localStorage.setItem("appId", this.openAppList[index].id);
                    localStorage.setItem(
                      "miniAppType",
                      this.openAppList[index].miniAppType
                    );
                    localStorage.setItem("appName", this.openAppList[index].appName);
                    localStorage.setItem("nowMini", JSON.stringify(this.openAppList[index]));
                    console.log(
                      index,
                      "index===56有传appkey的索引",
                      this.openAppList[index]
                    );
                  }
                }
              }

              if (localStorage.getItem("appId") != null) {
                const appId = localStorage.getItem("appId");
                for (let index in this.openAppList) {
                  if (this.openAppList[index].id == appId) {
                    this.isMerchant = this.openAppList[index].isMerchant;
                    this.appKey = this.openAppList[index].appKey;

                    localStorage.setItem("miniActive", index);
                    localStorage.setItem("appName", this.openAppList[index].appName);
                    localStorage.setItem("nowMini", JSON.stringify(this.openAppList[index]));
                    console.log(index, 'index=getItem("appId")');
                    break;
                  } else {
                    this.isMerchant = this.openAppList[0].isMerchant;
                    this.appKey = this.openAppList[0].appKey;
                  }
                }
              }
            }
            this.$refs.centerNav.getBuySeat();
            console.log(
              "debug:________________this.isMerchant______________是否显示授权资质",
              this.isMerchant
            );
            // if (this.$refs.router != undefined) {
            //   this.$refs.router.getBuySeat()
            // }
          } else {
            this.$message.error(res.data.info);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/index.vue